import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import LogoutButton from './LogoutButton';
import {withTranslation} from "react-i18next";

class TopbarProfile extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    this.setState({collapse: !this.state.collapse});
  };

  render() {
    const { collapse } = this.state;
    const { t } = this.props;

    return (
      <div className="topbar__profile">
        <button type="button" className="topbar__avatar" onClick={this.toggle}>
          <img className="topbar__avatar-img" src={`https://images.hive.blog/u/${this.props.auth.username}/avatar`} alt="avatar" />
          <p className="topbar__avatar-name">@{this.props.auth.username}</p>
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button type="button" className="topbar__back" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            <TopbarMenuLink title={t('menu.overview')} icon="list" path="/" onClick={this.toggle} />
            <TopbarMenuLink title={t('menu.wallet')} icon="inbox" path="/wallet" onClick={this.toggle} />

            { this.props.blogs.blog.title
              ? <a icon="inbox"
                  href={`https://${this.props.blogs.blog.domain}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={this.toggle}
                >
                  <div className="topbar__link">
                    <span className={`topbar__link-icon lnr lnr-pencil`} />
                    <p className="topbar__link-title">{`${t('topbar.visit_blog')} ${this.props.blogs.blog.title}`}</p>
                  </div>
                </a>

              : null }

            <div className="topbar__menu-divider" />
            <LogoutButton click={this.props.onLogout} />
          </div>
        </Collapse>
      </div>
    );
  }
}

export default withTranslation('dashboard')(TopbarProfile);
